import { MapClockIcon } from './MapClockIcon';

/**
 * author: Augustin Ursu
 * id A3A8668B-BEF0-48CC-AEB1-ACC765D10CC0
 * name map-clock
 * version: 3.3.92
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/map-clock.svg
 * tags
 * - Navigation 
 * - Geographic Information System 
 * - Date / Time 
 */
export const TimezoneIcon = MapClockIcon;
export default TimezoneIcon